import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Button.css';

// TODO: https://projectpine.atlassian.net/browse/FE-127

const Button = ({
  variant,
  children,
  isDisabled,
  htmlType,
  className: externalClasses,
  ...otherProps
}) => {
  const classNames = classnames(
    'ButtonNew',
    `ButtonNew--${variant}`,
    {
      'ButtonNew--disabled': isDisabled,
    },
    externalClasses,
  );

  return (
    // eslint-disable-next-line react/button-has-type
    <button type={htmlType} disabled={isDisabled} className={classNames} {...otherProps}>
      {children}
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'neutral', 'floating-action-button'])
    .isRequired,
  children: PropTypes.node.isRequired,
  htmlType: PropTypes.string,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  isDisabled: false,
  className: '',
  htmlType: 'button',
  onClick: Function.prototype,
};

export default Button;



// WEBPACK FOOTER //
// ../ui-components/components/ButtonNew/Button.jsx